<template>
    <div class="fill-height">
        <TabBasic :actualBreadcrumb="actualBreadcrumb" show-breadcrumbs>
            <template v-slot:header>
                <v-spacer/>
            </template>
            <v-container class="pa-0" fluid>
                <v-row>
                    <v-col>
                        <div>
                            <v-text-field
                                    v-model="search"
                                    class="datatable-search"
                                    dense
                                    hide-details
                                    outlined
                                    prepend-inner-icon="mdi-magnify"/>
                            <v-data-table
                                    v-model="selectedUsers"
                                    :headers="header"
                                    :items="filteredUsers"
                                    :loading="loading"
                                    :search="search"
                                    class="rounded-lg shadow my-6"
                                    item-key="UserID"
                                    selectable-key="isActive"
                                    show-select
                                    sort-by="Role">
                                <template v-slot:[`item.AvatarUrl`]="{item}">
                                    <v-avatar size="35">
                                        <img
                                                v-if="item.AvatarUrl"
                                                :src="item.AvatarUrl"
                                                alt="avatar">
                                        <v-icon v-else size="50">
                                            mdi-account-circle
                                        </v-icon>
                                    </v-avatar>
                                </template>
                                <template v-slot:[`item.actions`]="{ item }">
                                    <TableAction v-if="isAdmin && item.Status === USER_INVITED"
                                                 :tooltip="$t('tooltips.resendInvitation')"
                                                 icon="mdi-email-sync"
                                                 @click="resendInvitation(item.UserID)"/>
                                </template>
                                <template v-slot:[`item.Status`]="{item}">
                                    {{ getUserStatus(item.Status) }}
                                </template>
                            </v-data-table>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
            <div class="ml-3">
                <v-btn
                        :disabled="!selectedIDs.length"
                        :loading="loading"
                        class="accentText--text"
                        color="accent"
                        @click="addUsers">
                    {{ $t('circles.addToCircle') }}
                </v-btn>
            </div>
        </TabBasic>
    </div>
</template>

<script>
import MapBasic from "@/components/MapBasic/MapBasic";
import MyCircles from "@/components/Circles/MyCircles";
import TabBasic from "@/components/reusable/TabBasic/TabBasic";
import {CIRCLE_USER_ROLE_MANAGER, CIRCLE_USER_ROLE_USER, USER_ACTIVE, USER_INVITED} from "@/helper/constants";

export default {
  name: "CircleAddMembers",
  components: {TabBasic},
  mounted() {
    this.getOrganizationMembers();
  },
  data() {
    return {
      tab: null,
      circle: null,
      selectedUsers: [],
      circleUsers: [],
      users: [],
      loading: false,
      search: '',
      fab: true,
      items: [
        {
          title: this.$t('circles.map'),
          component: MapBasic
        },
        {
          title: this.$t('circles.myCircles'),
          component: MyCircles
        }
      ],
      openAddEditDialog: false,
      openInviteDialog: false,
      CIRCLE_USER_ROLE_USER,
      openPeopleDialog: false,
      user: {},
      USER_INVITED,
    };
  },
  computed: {
    filteredUsers() {
      const circleUsers = this.circleUsers.map(user => user.UserID);
      return this.users.filter((user) => !circleUsers.includes(user.UserID));
    },
    actualBreadcrumb() {
      if (this.circle) {
        return [{
          text: this.circle.Name + ' - ' + this.$t('circles.management'),
          to: {
            name: 'circleEdit',
            params: {
              id: this.$route.params.id
            }
          }
        },
          {
            text: this.$t('circles.addMember')
          }];
      }

      return [{
        text: this.$t('circles.addMember')
      }];
    },
    organizationId() {
      return this.$store.getters.getOrganizationId;
    },
    userID() {
      return this.$store.getters.getUserId;
    },
    isManager() {
      return this.circleUsers.filter(user => user.UserID === this.userID && user.Role === CIRCLE_USER_ROLE_MANAGER).length > 0;
    },
    header() {
      return [
        {text: this.$t('circles.avatar'), value: 'AvatarUrl'},
        {text: this.$t('authentication.firstName'), value: 'FirstName'},
        {text: this.$t('authentication.lastName'), value: 'LastName'},
        {text: this.$t('authentication.email'), value: 'Email'},
        {text: this.$t('status'), value: 'Status'},
        {text: '', value: 'actions', sortable: false, align: 'center'},
      ];
    },
    isAdmin() {
      return this.$store.getters.isOrganizationAdmin;
    },
    selectedIDs() {
      return this.selectedUsers.map((user) => user.UserID);
    }
  },
  methods: {
    getOrganizationMembers() {
      let url = this.$store.getters.circles(this.organizationId, this.$route.params.id);
      this.loading = true;
      this.axios.get(url).then(({data}) => {
        this.circle = data.Result;
      });
      url = this.$store.getters.circleUsers(this.organizationId, this.$route.params.id);
      this.axios.get(url).then(({data}) => {
        this.circleUsers = data.Result;
        if (!this.isManager) {
          this.$router.back();
        }
      }).finally(() => {
        this.loading = false;
      });

      url = this.$store.getters.getOrganizationUsers(this.organizationId);
      this.axios.get(url).then(({data}) => {
        this.users = data.Result.map((user) => ({...user, isActive: user.Status === USER_ACTIVE}));
      }).finally(() => {
        this.loading = false;
      });
    },
    deleteCircle() {
      this.$refs.deleteDialog.openDialog().then(result => {
        if (result) {
          const url = this.$store.getters.circle(this.circle.CircleID);
          this.axios.delete(url).then(() => {
            this.$router.push({name: 'myCircles'});
          });
        }
      });
    },
    deleteUser(userID) {
      this.$refs.deleteDialog.openDialog().then(result => {
        if (result) {
          const url = this.$store.getters.circleUser(this.circle.CircleID, userID);
          this.axios.delete(url).then(() => {
            this.getCircle();
          });
        }
      });
    },
    openUserSettings(user) {
      this.user = {...user};
      this.openPeopleDialog = true;
    },
    sendNotificationToUser() {
      this.$store.dispatch('addNotification', {
        type: 'warning',
        message: 'This functionality is under construction.',
      });
    },
    addUsers() {
      const url = this.$store.getters.circleUser(this.$route.params.id);
      this.loading = true;
      this.axios.post(url, this.selectedIDs).then(() => {
        this.$router.push({name: 'circleEdit', params: {id: this.$route.params.id}});
        this.$store.dispatch('addNotification', {
          type: 'success',
          message: this.$t('success.usersAdded'),
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    getUserStatus(status) {
      switch (status) {
        case USER_ACTIVE:
          return this.$t('user.active');
        case USER_INVITED:
          return this.$t('user.invited');
      }
      return status;
    },
    resendInvitation(userID) {
      const url = this.$store.getters.resendInvitation(userID);
      this.$store.dispatch('setLoader', true);
      this.axios.post(url).then(() => {
        this.$store.dispatch('addNotification', {
          type: 'success',
          message: this.$t('success.invitationWasResent'),
        });
      }).finally(() => {
        this.$store.dispatch('setLoader', false);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "circle-add-members";
</style>